export const LIST_DISCOUNT = '[Discount] List Discount';
